import {createNanoEvents} from 'nanoevents'

// Kept independent of the router so shared form logic can safely import the event bus.
export const applicationEvents = createNanoEvents()
